/**
 * @generated SignedSource<<1f62faa62c971de31d9b3b1a6ac612c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteParticipantMutation$variables = {
  id: string;
};
export type DeleteParticipantMutation$data = {
  readonly deleteParticipant: {
    readonly id: string;
  };
};
export type DeleteParticipantMutation = {
  response: DeleteParticipantMutation$data;
  variables: DeleteParticipantMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteParticipantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Participant",
        "kind": "LinkedField",
        "name": "deleteParticipant",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteParticipantMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Participant",
        "kind": "LinkedField",
        "name": "deleteParticipant",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b5b96953f99d3250a9099a19b0f28e4",
    "id": null,
    "metadata": {},
    "name": "DeleteParticipantMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteParticipantMutation(\n  $id: ID!\n) {\n  deleteParticipant(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b423eb78b23133b67fe7815f1e5b1103";

export default node;
